import Keycloak from "keycloak-js";

/*
const keycloak = new Keycloak({
 url: "https://tuckycenteraccess2.azurewebsites.net",
 realm: "tucky",
 clientId: "client_frontend",
});
*/

const keycloak = new Keycloak({
 url: process.env.REACT_APP_KEYCLOAK_URL,
 realm: "tucky",
 clientId: "client_frontend_pro",
});

export default keycloak;